module.exports = {
	"articleTitle1": "Off the beaten path",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Old Town Tavern",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/news/lumm-beats-rapundalo-incumbents-briere-kunselman-higgins-and-anglin-keep-seats",
	"articleSnippet1": "Oct 16, 2002 ... The Old Town Tavern is located at 122 W. Liberty St. ... Rio appears to be \ndecorated in the fashion of a local old-style tavern - with dim lighting, ...",
	"articleSnippet2": "Nov 9, 2011 ... Marlene Lacasse/Daily: City Council member Mike Anglin (D–Ward 5) at his \nwatch party at the Old Town Tavern on Tuesday, Nov. 8.",
	"foodRecommendations": [],
	"articleTitle2": "Oldest - ",
	"address": "122 W Liberty St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279807,
		"lng": -83.749697
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/oldtowntavern.json
// module id = 937
// module chunks = 0